import Constants from '@/Constants';
import { Question, QuestionCreateData } from '@/models/QuestionCreateData';
import http from '@/services/HttpService';
import { toast } from 'react-toastify';
import { call, put } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import { store } from '../index';
import { decreaseLessonQuestionsAmount, increaseLessonQuestionsAmount } from '../lesson/action';
import { getQuestionFailure } from '../questionnaire/action';
import {
    deleteQuestionFailure,
    deleteQuestionSuccess,
    getQuestionsFailure,
    getQuestionsSuccess,
    getQuestionSuccess,
    postQuestionFailure,
    postQuestionRenewSuccess,
    postQuestionSuccess,
    putQuestionFailure,
    putQuestionReorderFailure,
    putQuestionReorderSuccess,
    putQuestionSuccess,
} from './actions';
import { EvaluationQuestionTypes } from './types';

export function* getQuestionRequest(action: PayloadAction<EvaluationQuestionTypes.GET_QUESTION_REQUEST, number>) {
    try {
        const path = `${Constants.EVALUATION_QUESTIONS_URI}/${action.payload}`;
        const response = yield call(http.get, path);
        yield put(getQuestionSuccess(response.data));
    } catch (error) {
        yield put(getQuestionFailure(error));
    }
}

export function* getQuestionsRequest(action: PayloadAction<EvaluationQuestionTypes.GET_QUESTIONS_REQUEST, { entityId: number; entityType: string }>) {
    try {
        const { entityId, entityType } = action.payload;
        const path = `${Constants.EVALUATION_QUESTIONS_URI}/topic?entityId=${entityId}&entityType=${entityType}`;
        const response = yield call(http.get, path);
        yield put(getQuestionsSuccess(response.data));
    } catch (error) {
        yield put(getQuestionsFailure(error));
    }
}

export function* postQuestion(action: PayloadAction<EvaluationQuestionTypes.POST_QUESTION_REQUEST, QuestionCreateData>) {
    try {
        const {
            locale: { data },
        } = store.getState();

        const payload = action.payload;
        const path = Constants.FLOWLMS_QUESTIONS_URI.replace('%lessonId', payload.lessonId.toString());
        const response = yield call(http.post, path, payload);
        toast.success(data.QUESTION_SAVE_SUCCESS);
        yield put(postQuestionSuccess(response.data));
        yield put(increaseLessonQuestionsAmount(payload.lessonId));
    } catch (error) {
        yield put(postQuestionFailure(error));
    }
}

export function* postQuestionRenew(action: PayloadAction<EvaluationQuestionTypes.POST_QUESTION_RENEW_REQUEST, QuestionCreateData>) {
    try {
        const {
            locale: { data },
        } = store.getState();

        const payload = action.payload;
        const path = Constants.FLOWLMS_QUESTIONS_URI.replace('%lessonId', payload.lessonId.toString());
        const response = yield call(http.post, path, payload);
        toast.success(data.QUESTION_SAVE_SUCCESS);
        yield put(postQuestionRenewSuccess(response.data));
        yield put(increaseLessonQuestionsAmount(payload.lessonId));
    } catch (error) {
        yield put(postQuestionFailure(error));
    }
}

export function* putQuestion(action: PayloadAction<EvaluationQuestionTypes.PUT_QUESTION_REQUEST, Question>) {
    try {
        const {
            locale: { data },
        } = store.getState();

        const { id } = action.payload;
        yield call(http.put, `${Constants.EVALUATION_QUESTIONS_URI}/${id}`, action.payload);
        toast.success(data.QUESTION_SAVE_SUCCESS);
        yield put(putQuestionSuccess(action.payload));
    } catch (error) {
        yield put(putQuestionFailure(error));
    }
}

export function* putQuestionReorderRequest(
    action: PayloadAction<EvaluationQuestionTypes.PUT_QUESTION_REORDER_REQUEST, { topicId: number; questionId: number; order: number }>,
) {
    try {
        const { topicId, questionId, order } = action.payload;
        yield call(http.put, `${Constants.EVALUATION_TOPICS_URI}/${topicId}/questions/${questionId}/reorder/${order}`);
        yield put(putQuestionReorderSuccess());
    } catch (error) {
        yield put(putQuestionReorderFailure(error));
    }
}

export function* deleteQuestion(action: PayloadAction<EvaluationQuestionTypes.DELETE_QUESTION_REQUEST, { questionId: number; lessonId: number }>) {
    const {
        locale: { data },
    } = store.getState();
    try {
        const { questionId, lessonId } = action.payload;
        const path = Constants.FLOWLMS_DELETE_QUESTIONS_URI.replace('%lessonId', lessonId.toString()).replace('%questionId', questionId.toString());
        yield call(http.delete, path);
        yield put(deleteQuestionSuccess(questionId, lessonId));
        yield put(decreaseLessonQuestionsAmount(lessonId));
    } catch (error) {
        toast.error(data.toastMessages.QUESTION_REMOVE_ERROR);
        yield put(deleteQuestionFailure(error));
    }
}
